<div *ngIf="imageVisible" class="file-upload-wrapper"
  style="border: 1px solid #cbd5e1; border-radius: 6px; padding: 8px 12px; background: #ffffff; display: flex; align-items: center; justify-content: space-between; gap: 12px; width: 100%; box-sizing: border-box; min-width: 0;">

  <!-- Selected Files List Container -->
  <div class="file-items-list" style="display: flex; flex-wrap: wrap; align-items: center; gap: 8px; flex: 1; min-width: 0; overflow: hidden;">

    <div *ngFor="let item of getValueList(); let i = index" class="file-badge-chip"
      style="display: inline-flex; align-items: center; gap: 6px; background: #f8fafc; border: 1px solid #cbd5e1; border-radius: 4px; padding: 3px 8px; max-width: 100%; min-width: 0; box-sizing: border-box;">

      <!-- Image thumbnail if image -->
      <ng-container *ngIf="isImageFile(item); else iconTpl">
        <calsoft-common-images [src]="serverPath + item" [height]="'26px'" [width]="'26px'" style="flex-shrink: 0; display: inline-flex; align-items: center;">
        </calsoft-common-images>
      </ng-container>

      <!-- Non-image Icon -->
      <ng-template #iconTpl>
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #e53935; flex-shrink: 0; line-height: 20px;">
          {{ getFileIcon(item) }}
        </mat-icon>
      </ng-template>

      <!-- File Name -->
      <span [title]="getDisplayFileName(item)"
        style="font-size: 12px; color: #1e293b; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 180px; font-weight: 500; min-width: 0;">
        {{ getDisplayFileName(item) }}
      </span>

      <!-- Remove Button -->
      <button type="button" mat-icon-button color="warn"
        style="width: 22px; height: 22px; line-height: 22px; flex-shrink: 0; padding: 0;"
        (click)="removeSingleFile(i)" title="Remove file">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; line-height: 16px;">close</mat-icon>
      </button>
    </div>

    <!-- Empty State -->
    <span *ngIf="!getValueList() || getValueList().length === 0"
      style="font-size: 12px; color: #94a3b8; font-style: italic;">
      No file selected
    </span>
  </div>

  <!-- Upload Action Button -->
  <div class="upload-action-btn" style="flex-shrink: 0; display: flex; align-items: center;">
    <button [attr.guide]="'file-upload-btn-2-1' + '__' + sanitizeUrl(url)" type="button" (click)="logo()"
      mat-raised-button color="primary"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 0 14px; height: 34px; border-radius: 4px; font-weight: 500; white-space: nowrap;">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; margin: 0;">cloud_upload</mat-icon>
      <span>Upload</span>
    </button>
  </div>
</div>

<div *ngIf="!imageVisible && !imageDelete"
  style="border: 1px solid #cbd5e1; border-radius: 6px; padding: 12px; background: #ffffff; display: flex; align-items: center; justify-content: space-between; gap: 12px; width: 100%; box-sizing: border-box;">
  <div style="flex: 1; min-width: 0;">
    <calsoft-common-file-upload (fileUploadResult)="getResult($event)" [type]="'gallery'" [multiple]="(field && field.multiple !== false)">
    </calsoft-common-file-upload>
  </div>
  <button [attr.guide]="'file-upload-btn-4-1' + '__' + sanitizeUrl(url)" (click)="cancelUpload()" type="button"
    mat-raised-button style="flex-shrink: 0; height: 34px;">Cancel</button>
</div>